import { Appointment } from '@myapp/contract'
import { useUpdateAppointment } from '../../../entities/appointment'
import { CalendarPlanningOverlay } from '../../calendar-planning-overlay'

interface Props {
  show: boolean
  onClose: () => void
  onSuccess: () => void
  appointment: Appointment
  technicianId: number
}

export function WorkerAppointmentReschedulePlanOverlay({
  show,
  onClose,
  onSuccess,
  appointment,
  technicianId,
}: Props) {
  const updateAppointment = useUpdateAppointment()

  const initialSelectedDate = (() => {
    const d = new Date(appointment.plannedStart)
    if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0) return null
    return appointment.plannedStart
  })()

  return (
    <CalendarPlanningOverlay
      show={show}
      onClose={onClose}
      technicianId={technicianId}
      initialSelectedDate={initialSelectedDate}
      initialWorkDuration={appointment.plannedWorkDuration ?? 60}
      initialTravelDuration={appointment.plannedTravelDuration ?? 30}
      initialDepartureDuration={appointment.plannedDepartureDuration ?? 30}
      excludeAppointmentId={appointment.id}
      headerTitle="Termin umplanen"
      saveButtonColor="#124093"
      draftTitle={appointment.workOrder?.external.gebaeude ?? 'Termin'}
      hintText="Tippe auf eine Uhrzeit im Kalender, um den Termin zu setzen"
      onSave={async (payload) => {
        await updateAppointment.mutateAsync({
          id: appointment.id,
          dto: {
            plannedStart: payload.plannedStart,
            plannedWorkDuration: payload.plannedWorkDuration,
            plannedTravelDuration: payload.plannedTravelDuration,
            plannedDepartureDuration: payload.plannedDepartureDuration,
          },
        })
        onSuccess()
      }}
      isPending={updateAppointment.isPending}
    />
  )
}
